export function needsQuantityVerification(part) {
  return Boolean(part?.quantityNeedsVerification)
}

export function needsModelVerification(part) {
  return Boolean(part?.modelNeedsVerification)
}

export function getStockStatus(part) {
  if (needsQuantityVerification(part)) return 'unverified'
  const qty = Number(part?.quantity) || 0
  const min = Number(part?.minimumStock ?? part?.minStock) || 0
  if (qty === 0) return 'out'
  if (min > 0 && qty <= min) return 'low'
  if (qty > 0) return 'ok'
  return 'out'
}

export function getStockStatusLabel(status) {
  if (status === 'unverified') return '수량 미확인'
  if (status === 'out') return '재고 없음'
  if (status === 'low') return '재고 부족'
  return '재고 있음'
}

export function formatCurrentStock(part) {
  if (needsQuantityVerification(part)) return '미확인'
  const unit = part?.unit || '개'
  return `${Number(part?.quantity) || 0}${unit}`
}

export function getReviewStatus(part) {
  const qty = needsQuantityVerification(part)
  const model = needsModelVerification(part)
  if (qty && model) return 'qty-spec'
  if (qty) return 'qty'
  if (model) return 'spec'
  return 'done'
}

export function getReviewStatusLabel(status) {
  if (status === 'qty-spec') return '수량·사양 미확인'
  if (status === 'qty') return '수량 미확인'
  if (status === 'spec') return '사양 미확인'
  return '검수완료'
}

export function needsReview(part) {
  return needsQuantityVerification(part) || needsModelVerification(part)
}

export function isMergedPart(part) {
  return Boolean(part?.mergedIntoPartId)
}

export function getReviewCounts(parts) {
  const counts = { needed: 0, 'qty-spec': 0, qty: 0, spec: 0, done: 0 }
  for (const part of parts) {
    const qty = needsQuantityVerification(part)
    const model = needsModelVerification(part)
    if (qty) counts.qty += 1
    if (model) counts.spec += 1
    if (qty && model) counts['qty-spec'] += 1
    if (qty || model) counts.needed += 1
    else counts.done += 1
  }
  return counts
}

export function matchesReviewTab(part, tab) {
  if (tab === 'needed' || tab === 'all') return needsReview(part)
  if (tab === 'qty') return needsQuantityVerification(part)
  if (tab === 'spec') return needsModelVerification(part)
  if (tab === 'qty-spec') return needsQuantityVerification(part) && needsModelVerification(part)
  if (tab === 'done') return !needsReview(part)
  return true
}

export function matchesReviewFilter(part, filter) {
  if (filter === 'all') return true
  if (filter === 'needed') return needsReview(part)
  if (filter === 'qty') return needsQuantityVerification(part)
  if (filter === 'spec') return needsModelVerification(part)
  if (filter === 'qty-spec') return needsQuantityVerification(part) && needsModelVerification(part)
  if (filter === 'done') return !needsReview(part)
  return true
}

export function specOrPending(value) {
  const text = String(value ?? '').trim()
  if (!text) return { text: '확인필요', pending: true }
  if (text === '해당없음') return { text, pending: false, na: true }
  return { text, pending: false }
}

export function signedTransactionQty(tx) {
  const type = String(tx?.type || '').toUpperCase()
  const qty = Number(tx?.quantity) || 0
  if (type === 'OUT') return -qty
  if (type === 'ADJUSTMENT' || type === 'ADJUST' || type === 'MERGE') {
    const after = Number(tx.afterQuantity ?? tx.balanceAfter)
    const before = Number(tx.beforeQuantity ?? tx.previousQuantity)
    if (Number.isFinite(after) && Number.isFinite(before)) return after - before
  }
  return qty
}

export function formatSignedQty(value) {
  const n = Number(value) || 0
  if (n > 0) return `+${n}`
  return String(n)
}

export function partTitle(part) {
  return part?.model || part?.name || part?.partCode || '-'
}
